var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "index-page" },
    [
      _c("header-cmp"),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page-part" },
        [
          _c(
            "el-carousel",
            {
              staticClass: "page-part",
              attrs: {
                height: "500px",
                trigger: "hover",
                "indicator-position": "outside"
              }
            },
            _vm._l(_vm.banners, function(banner) {
              return _c("el-carousel-item", { key: banner.index }, [
                _c("div", {
                  class:
                    "banner banner-0" +
                    banner.index +
                    " " +
                    (banner.redirect || banner.url ? "pointer" : "") +
                    " "
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: banner.url,
                        expression: "banner.url"
                      }
                    ],
                    staticClass: "banner-cover",
                    on: {
                      click: function($event) {
                        return _vm.bannerClick(banner)
                      }
                    }
                  },
                  [_c("i", { staticClass: "icon icon-play" })]
                )
              ])
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("section", { staticClass: "page-part bg", attrs: { id: "inquiry" } }, [
        _c("div", { staticClass: "page-inner user-buttons" }, [
          _c(
            "div",
            {
              staticClass: "deliver-bg user-button",
              on: {
                click: function($event) {
                  return _vm.$router.push({
                    name: "deliver",
                    query: { nodump: true }
                  })
                }
              }
            },
            [_c("div", { staticClass: "deliver icon" }), _vm._v(" "), _vm._m(0)]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "inquiry-bg user-button",
              on: {
                click: function($event) {
                  return _vm.$router.push({
                    name: "inquiry",
                    query: { nodump: true }
                  })
                }
              }
            },
            [_c("div", { staticClass: "inquiry icon" }), _vm._v(" "), _vm._m(1)]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page-part record", attrs: { id: "record" } },
        [
          _c("div", { staticClass: "page-inner" }, [
            _c("h3", { staticClass: "text-primary record-title" }, [
              _vm._v("成交记录")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "scroll-part" },
              [_c("scroll-table-cmp", { attrs: { records: _vm.recordList } })],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page-part download bg", attrs: { id: "download" } },
        [
          _c("div", { staticClass: "page-inner" }, [
            _c("h3", { staticClass: "download-title" }, [_vm._v("产品下载")]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "card-bottom" }, [
                _c("div", {
                  staticClass:
                    "icon icon-qrcode icon-qrcode_huozhu card-bottom-left"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-bottom-right" }, [
                  _c("span", [_vm._v("扫码下载安卓版/iOS版")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-download",
                      on: {
                        click: function($event) {
                          return _vm.download("huozhu")
                        }
                      }
                    },
                    [_vm._v("\n              点击下载\n            ")]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "card-bottom" }, [
                _c("div", {
                  staticClass:
                    "icon icon-qrcode icon-qrcode_siji card-bottom-left"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-bottom-right" }, [
                  _c("span", [_vm._v("扫码下载安卓版/iOS版")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-download",
                      on: {
                        click: function($event) {
                          return _vm.download("siji")
                        }
                      }
                    },
                    [_vm._v("\n              点击下载\n            ")]
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c("footer-cmp"),
      _vm._v(" "),
      _c("modal-cmp", {
        attrs: {
          open: _vm.videoModalVisible,
          mode: "video",
          videoSrc: _vm.videoSrc
        },
        on: {
          "update:open": function($event) {
            _vm.videoModalVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text inline-block" }, [
      _c("h3", { staticClass: "title" }, [_vm._v("立即发货")]),
      _vm._v(" "),
      _c("p", { staticClass: "desc" }, [_vm._v("点击发布，选合适的司机")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text inline-block" }, [
      _c("h3", { staticClass: "title" }, [_vm._v("立即询价")]),
      _vm._v(" "),
      _c("p", { staticClass: "desc" }, [_vm._v("价格预估，运货无忧")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-top" }, [
      _c("div", { staticClass: "icon huozhu" }),
      _vm._v(" "),
      _c("h1", [_vm._v("我是货主")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-top" }, [
      _c("div", { staticClass: "icon siji" }),
      _vm._v(" "),
      _c("h1", [_vm._v("我是司机")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "page-part partner", attrs: { id: "partner" } },
      [
        _c("div", { staticClass: "page-inner" }, [
          _c("h3", { staticClass: "partner-title" }, [_vm._v("合作伙伴")]),
          _vm._v(" "),
          _c("div", { staticClass: "icon logo" }),
          _vm._v(" "),
          _c("div", { staticClass: "icon logo" }),
          _vm._v(" "),
          _c("div", { staticClass: "icon logo" }),
          _vm._v(" "),
          _c("div", { staticClass: "icon logo" }),
          _vm._v(" "),
          _c("div", { staticClass: "icon logo" }),
          _vm._v(" "),
          _c("div", { staticClass: "icon logo" }),
          _vm._v(" "),
          _c("div", { staticClass: "icon logo" }),
          _vm._v(" "),
          _c("div", { staticClass: "icon logo" }),
          _vm._v(" "),
          _c("div", { staticClass: "icon logo" }),
          _vm._v(" "),
          _c("div", { staticClass: "icon logo" })
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-a83bd3b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-a83bd3b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = null
// module chunks = 